import type { FrontModule } from "@nabble/sdk";
import { lazy } from "react";
import { PERMISSIONS } from "./api";

const ChatPage = lazy(() => import("./pages/ChatPage"));

export const chatModule: FrontModule = {
  id: "chat",
  version: "0.1.0",
  permission: PERMISSIONS.use,
  label: "Chat",
  icon: "message",
  description: "Talk with your colleagues in channels and direct messages.",
  routes: [
    { path: "/chat", Component: ChatPage },
    { path: "/chat/:conversationId", Component: ChatPage },
  ],
  menu: [
    {
      id: "chat.home",
      label: "Chat",
      icon: "message",
      path: "/chat",
      permission: PERMISSIONS.use,
      description: "Channels and direct messages",
    },
  ],
};

export default chatModule;
